import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE;

// 1. Buat Instance
const apiClient = axios.create({
  baseURL: API_BASE,
  timeout: 300000,   // 300s — expert reasoning + LLM bisa > 2 menit
});

// 2. PASANG PENYADAP (INTERCEPTOR)
apiClient.interceptors.request.use(
  (config) => {
    // Ambil token dari brankas
    const token = localStorage.getItem("token");
    
    // DEBUGGER: Cek di Console Browser nanti!
    if (token) {
        // console.log(`[AGENT SERVICE] Request ke ${config.url} MEMBAWA Token.`);
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        // Hanya warn untuk endpoint yang butuh auth
        if (!config.url.includes("/auth/") && !config.url.includes("/ping")) {
          console.warn(`[AGENT SERVICE] No token for: ${config.url}`);
        }
    }

    // Set language header for bilingual responses
    const lang = localStorage.getItem("tacia_language") || "id";
    config.headers["Accept-Language"] = lang;

    return config;
  },
  (error) => Promise.reject(error)
);

// --- API FUNCTIONS ---

export const fetchAgents = async (signal = null) => {
  const res = await apiClient.get("/agent", { signal });
  return res.data;
};

export const fetchAgentById = async (agentId) => {
  const res = await apiClient.get(`/agent/${agentId}`);
  return res.data;
};

export const updateAgentById = async (agentId, updatedFields) => {
  const res = await apiClient.put(`/agent/${agentId}`, updatedFields);
  return res.data;
};

export const createAgent = async (agentData) => {
  const res = await apiClient.post("/agent", agentData);
  return res.data;
};

export const deleteAgent = async (agentId) => {
  const res = await apiClient.delete(`/agent/${agentId}`);
  return res.data;
};

export const runAgent = async (runData) => {
  const lang = localStorage.getItem("tacia_language") || "id";
  const res = await apiClient.post("/agent/runAgent", {
    language: lang,
    ...runData,
  });
  return res.data;
};

export const fetchChatHistory = async (agentId) => {
  const res = await apiClient.get(`/agent/${agentId}/history`);
  return res.data;
};

export const clearChatHistory = async (agentId) => {
  const res = await apiClient.delete(`/agent/${agentId}/history`);
  return res.data;
};

export const analyzeSurat = async (files, agentId, userMessage = "") => {
  const formData = new FormData();
  const fileList = Array.isArray(files) ? files : [files];
  fileList.forEach((f) => {
    if (f) formData.append("files", f);
  });
  formData.append("agent_id", agentId);
  const lang = localStorage.getItem("tacia_language") || "id";
  formData.append("language", lang);
  if (userMessage) formData.append("user_message", userMessage);
  const res = await apiClient.post("/agent/analyze-surat", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 300000,
  });
  return res.data;
};